import { Component } from '@angular/core';

@Component({
    selector: 'app-ecitation-all-report',
    templateUrl: './ecitation-all-report.component.html',
    styleUrls: ['./ecitation-all-report.component.css'],
    standalone: false
})
export class EcitationAllReportComponent {
  selectedTab = 'all';
  showTable = true;
}
